const orange = {
    100: 'rgb(246, 201, 162)',
    200: 'rgb(243, 180, 124)',
    300: 'rgb(239, 158, 87)',
    400: 'rgb(236, 137, 50)',
    500: 'rgb(224, 116, 21)',
    600: 'rgb(187, 96, 17)',
    700: 'rgb(149, 77, 14)',
    800: 'rgb(112, 58, 10)',
};
export default orange;
